import SuperAdminEditProfile from './SuperAdminEditProfile'

export { SuperAdminEditProfile }
